module.exports = __webpack_public_path__ + "img/introduce_kr.00c464d1.png";